<template>
  <div class="ai-assistant-container">
    <div v-if="!aioff">
      <div>是否开启AI助手，需要读取您的pdf内容</div>
      <div style="margin-top: 10px;">
        <el-button type="primary" icon="el-icon-chat-dot-square" @click="openaioff" class="send-btn" >开启</el-button>
      </div>
    </div>
    <div v-else>
      <div class="assistant-tip">
        <i class="el-icon-info-circle" />
        DeepSeek PDF助手｜多轮对话
      </div>
      <!-- 聊天内容区域：窄屏滚动优化 -->
      <div class="chat-content" ref="chatContent">
        <!-- 空对话状态：窄屏居中适配 -->
        <div class="empty-chat" v-if="chatList.length === 0">
          输入问题开始咨询吧～
        </div>

        <!-- 历史对话列表：窄屏紧凑化 -->
        <div class="chat-item" v-for="(item, index) in chatList" :key="index">
          <!-- 用户消息：右对齐+蓝色气泡+白色文字+专属圆角 -->
          <div class="user-chat" v-if="item.role === 'user'">
            <div class="avatar">
              <i class="el-icon-user" />
            </div>
            <div class="message">{{ item.content }}</div>
          </div>
          <!-- AI消息：左对齐+浅灰气泡+Markdown渲染+加载状态 -->
          <div class="ai-chat" v-else>
            <div class="avatar">
              <i class="iconfont icon-jiqiren" />
            </div>
            <div class="message" v-if="!item.loading">
              <!-- Markdown渲染AI回答，适配窄屏 -->
              <vue-markdown class="md-content" :source="item.content" />
            </div>
            <!-- 窄屏减少骨架屏行数，避免占高 -->
            <div class="loading-text" v-else>
              <el-skeleton :rows="2" animated />
            </div>
          </div>
        </div>
      </div>
      <!-- 操作区域：窄屏垂直布局+紧凑化 -->
      <div class="chat-footer">
        <!-- 清空按钮：右对齐+窄屏小尺寸 -->
        <el-button type="text" icon="el-icon-delete" @click="clearChat" class="clear-btn">
          清空
        </el-button>
        <!-- 输入框：窄屏适配行数+占满宽度 -->
        <el-input v-model="question" placeholder="请输入PDF相关问题..." type="textarea" :rows="2"
          @keyup.enter.native="sendQuestion" :disabled="loading" />
        <!-- 发送按钮：窄屏紧凑尺寸+右对齐 -->
        <el-button type="primary" icon="el-icon-s-promotion" @click="sendQuestion" :loading="loading" class="send-btn">
          发送
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 引入Markdown渲染组件（Vue2专属，需安装依赖）
import VueMarkdown from 'vue-markdown'
// 引入Markdown基础样式（可选，保证列表/代码块等基础格式）
// import 'vue-markdown/dist/vue-markdown.css'

export default {
  name: 'AIAssistant',
  // 注册Markdown组件
  components: { VueMarkdown },
  props: {
    // 父组件传递的PDF提取文本，必传
    pdfText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      question: '', // 用户输入的问题
      chatList: [], // 历史对话列表
      loading: false, // 请求加载状态
      aioff:false, //ai功能开启
    };
  },
  watch: {
    // 对话列表变化自动滚动到底部（包含Markdown渲染后的内容）
    chatList() {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
  },
  methods: {
    openaioff(){
      if (!this.$parent.pdfbase64) {
        this.$message.error('请先上传PDF！');
        return;
      }
      this.aioff = true;
      this.$parent._extractPdfText()
    },
    /**
     * 滚动聊天区域到底部（适配Markdown渲染后的高度）
     */
    scrollToBottom() {
      const chatContent = this.$refs.chatContent;
      if (chatContent) {
        chatContent.scrollTop = chatContent.scrollHeight;
      }
    },

    /**
     * 清空历史对话
     */
    clearChat() {
      if (this.chatList.length === 0) {
        this.$message.info('暂无对话记录');
        return;
      }
      this.chatList = [];
      this.$message.success('已清空对话');
    },

    /**
     * 封装后端接口请求方法
     */
    async requestApi(params) {
      try {
        const response = await fetch(this.aiurl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(params)
        });
        return await response.json();
      } catch (error) {
        this.$message.error('网络异常，请检查后端是否启动！');
        throw new Error('网络请求失败：' + error.message);
      }
    },

    /**
     * 发送问题核心方法（已修复索引Bug）
     */
    async sendQuestion() {
      const trimedQuestion = this.question.trim();
      if (!trimedQuestion) {
        this.$message.warning('请输入有效的问题！');
        return;
      }
      if (!this.pdfText || !this.pdfText.trim()) {
        this.$message.error('请先上传PDF并提取文本！');
        return;
      }
      if (this.loading) return;

      try {
        this.loading = true;
        // 添加用户消息
        this.chatList.push({
          role: 'user',
          content: trimedQuestion
        });
        this.question = '';

        // 添加AI加载消息并记录真实索引
        this.chatList.push({
          role: 'assistant',
          content: '',
          loading: true
        });
        const aiLoadingIndex = this.chatList.length - 1;

        // 构造请求参数
        const requestParams = {
          question: trimedQuestion,
          pdfText: this.pdfText.trim(),
          history: this.chatList.slice(0, -1)
        };

        // 调用后端接口
        const res = await this.requestApi(requestParams);

        // 处理响应
        if (res.code === 200 && res.data) {
          this.chatList.splice(aiLoadingIndex, 1, {
            role: 'assistant',
            content: res.data,
            loading: false
          });
        } else {
          this.$message.error(res.msg || 'AI回答失败！');
          this.chatList.splice(aiLoadingIndex, 1);
        }
      } catch (error) {
        this.chatList.pop();
        this.$message.error('请求异常：' + error.message);
        console.error('AI请求异常：', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* 根容器：适配父组件256px宽度，高度100%，紧凑化布局 */
.ai-assistant-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px;
  /* 窄屏减少内边距 */
  box-sizing: border-box;
  background: #f5f7fa;
  font-size: 12px;
  /* 窄屏全局缩小字体 */
}

/* 头部提示：窄屏精简样式 */
.assistant-tip {
  color: #606266;
  padding: 4px 8px;
  background: #eef2f7;
  border-radius: 4px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.assistant-tip i {
  color: #409eff;
  margin-right: 4px;
  font-size: 14px;
}

/* 聊天内容区域：窄屏核心适配，占满剩余高度 */
.chat-content {
  flex: 1;
  overflow: auto;
  background: #fff;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 8px;
  /* height: calc(100% - 120px); */
  height: calc(100vh - 230px);
  /* 窄屏调整高度，适配输入框+按钮 */
}

/* 空对话状态：窄屏居中，轻量提示 */
.empty-chat {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

/* 单条对话项：窄屏紧凑化，减少间距 */
.chat-item {
  width: 100%;
  /* display: flex; */
  margin-bottom: 12px;
  /* 窄屏减少对话间距 */
  align-items: flex-start;
  /* 顶部对齐，避免头像和气泡错位 */
  text-align: left;
}

.chat-item:last-child {
  margin-bottom: 0;
}

/* 头像通用：窄屏缩小尺寸（32px），紧凑化 */
.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  /* 禁止头像压缩 */
  margin-bottom: 8px;
  /* 窄屏减少间距 */
  font-size: 14px;
}

.avatar i {
  font-size: 14px;
}

/* 消息气泡通用：窄屏提高可用宽度（80%），紧凑内边距 */
.message {
  /* max-width: 80%; */
  /* 窄屏调大占比，充分利用空间 */
  padding: 6px 10px;
  /* 窄屏减少内边距 */
  border-radius: 6px;
  line-height: 1.5;
  word-wrap: break-word;
  /* 强制换行核心属性 */
  word-wrap: break-word; /* 普通文本换行 */
  word-break: break-all; /* 长串无空格字符强制换行（关键） */
  overflow-wrap: break-word; /* 兼容多浏览器 */
}

/* 加载状态：窄屏适配，减少占高 */
.loading-text {
  max-width: 80%;
  padding: 4px 0;
}

/* ---------------------- 用户消息：强视觉区分 ---------------------- */
.user-chat {
  flex-direction: row-reverse;
  /* 右对齐 */
  display: flex;
  flex-direction: column;
  align-items: end;
}

.user-chat .avatar {
  margin-right: 0;
  margin-left: 0px;
  margin-bottom: 8px;
  background: #409eff;
  /* 主色调背景 */
  color: #fff;
  /* 白色图标 */
}

.user-chat .message {
  background: #409eff;
  /* 蓝色气泡，和头像呼应 */
  color: #fff;
  /* 白色文字，对比强烈 */
  border-radius: 6px;
}

/* ---------------------- AI消息：弱视觉对比，和用户区分 ---------------------- */
.ai-chat{
  /* display: flex; */
}
.ai-chat .avatar {
  background: #eef2f7;
  /* 浅灰背景 */
  color: #606266;
  /* 灰色图标 */
}

.ai-chat .message {
  background: #f5f7fa;
  /* 浅灰气泡，柔和不刺眼 */
  color: #333;
  border-radius: 6px;
}

/* 底部操作区域：窄屏垂直布局，全宽适配 */
.chat-footer {
  display: flex;
  flex-direction: column;
  gap: 6px;
  /* 窄屏减少间距 */
  width: 100%;
}

/* 清空按钮：窄屏小尺寸，右对齐 */
.clear-btn {
  color: #f56c6c;
  align-self: flex-end;
  padding: 0;
  /* 清空默认内边距 */
  font-size: 12px;
}

/* 输入框：窄屏占满宽度，精简样式 */
.chat-footer el-input {
  width: 100%;
}

/* 穿透修改Element输入框样式，适配窄屏 */
.chat-footer el-input /deep/ .el-textarea__inner {
  resize: none;
  border-radius: 6px;
  font-size: 12px;
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
}

/* 禁用状态输入框样式优化 */
.chat-footer el-input /deep/ .el-textarea__inner:disabled {
  background: #fafafa;
  color: #909399;
}

/* 发送按钮：窄屏紧凑化，右对齐 */
.send-btn {
  align-self: flex-end;
  padding: 6px 16px;
  /* 窄屏缩小按钮 */
  font-size: 12px;
  border-radius: 6px;
}

/* ---------------------- Markdown渲染样式：窄屏专属重置 ---------------------- */
/* 穿透修改Markdown内容样式，适配256px窄屏 */
.message /deep/ .md-content {
  line-height: 1.5;
  font-size: 12px;
  width: 100%;
}

/* 重置Markdown默认标题样式，避免字号过大 */
.message /deep/ .md-content h1,
.message /deep/ .md-content h2,
.message /deep/ .md-content h3,
.message /deep/ .md-content h4 {
  font-size: 13px;
  margin: 4px 0;
  font-weight: 600;
}

/* 重置列表样式，减少缩进和间距 */
.message /deep/ .md-content ul,
.message /deep/ .md-content ol {
  padding-left: 16px;
  margin: 2px 0;
}

/* 重置段落样式，紧凑化 */
.message /deep/ .md-content p {
  margin: 2px 0;
}

/* 重置代码块样式，适配窄屏 */
.message /deep/ .md-content code {
  padding: 1px 3px;
  background: #eef2f7;
  border-radius: 2px;
  font-size: 11px;
}

/* 重置分割线，窄屏适配 */
.message /deep/ .md-content hr {
  margin: 6px 0;
  border: 0;
  border-top: 1px solid #eef2f7;
}
</style>